import React, { useMemo } from "react";
import { TransactionStatus } from "@common/types/transaction";
import classNames from "classnames";
import { LinkIcon } from "@icons";
import { FinancialAccount } from "@common/types/financialAccount";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { TransactionDateColumnContent } from "../../ListItem/TransactionDateColumnContent";
import { TransactionDescriptionColumnContent } from "../../ListItem/TransactionDescriptionColumnContent";
import { TransactionAccountColumnContent } from "../../ListItem/TransactionAccountColumnContent";
import { TransactionAmount } from "../../TransactionAmount";
import styles from "./ReconcileGustoTransfersModal.module.scss";

interface VirtualTransactionProps {
    transaction: TransactionListItem;
    gustoAccount: FinancialAccount | null;
}

export const VirtualTransactionMatch: React.FC<VirtualTransactionProps> = ({
    transaction,
    gustoAccount,
}) => {
    const virtualTransaction = useMemo(
        () => ({
            ...transaction,
            bankDescription: "Reconciliation transaction",
            displayDescription: "Reconciliation transaction",
            amount: -transaction.amount,
            financialAccount: gustoAccount,
            status: TransactionStatus.COMPLETED,
        }),
        [transaction, gustoAccount],
    ) as TransactionListItem;

    if (!gustoAccount) {
        return null;
    }

    return (
        <div className={styles.matchContainer}>
            <div className={classNames(styles.gridContent, styles.tableHeader)}>
                <div>Date</div>
                <div>Description</div>
                <div>Account</div>
                <div className="text-right">Amount</div>
            </div>
            <div
                className={classNames(
                    styles.gridContent,
                    styles.transactionContent,
                    styles.originalTransaction,
                )}
            >
                <div>
                    <TransactionDateColumnContent transaction={transaction} />
                </div>
                <div>
                    <TransactionDescriptionColumnContent
                        transaction={transaction}
                    />
                </div>
                <div>
                    <TransactionAccountColumnContent
                        transaction={transaction}
                    />
                </div>
                <div>
                    <TransactionAmount
                        className={classNames(styles.amount, "text-right")}
                        transaction={transaction}
                        addSign
                        color
                    />
                </div>
            </div>
            <div className={styles.linkIconContainer}>
                <div className={styles.linkIconBox}>
                    <LinkIcon
                        className={classNames(
                            styles.linkIcon,
                            "icon-color-gray-900",
                        )}
                    />
                </div>
            </div>
            <div
                className={classNames(
                    styles.gridContent,
                    styles.transactionContent,
                    styles.virtualTransaction,
                )}
            >
                <div>
                    <TransactionDateColumnContent
                        transaction={virtualTransaction}
                    />
                </div>
                <div>
                    <TransactionDescriptionColumnContent
                        transaction={virtualTransaction}
                    />
                </div>
                <div>
                    <TransactionAccountColumnContent
                        transaction={virtualTransaction}
                    />
                </div>
                <div>
                    <TransactionAmount
                        className={classNames(styles.amount, "text-right")}
                        transaction={virtualTransaction}
                        addSign
                        color
                    />
                </div>
            </div>
        </div>
    );
};
